<div class="inventory-cart-shipping">
    <hr />
    <h3><i class="fa fa-credit-card-alt" aria-hidden="true"></i> &nbsp;{{'nuvei.paymentSection.mainTitle' | translate}}
    </h3>
    <hr />
    <br />
</div>

<div id="nuvei-payment-form" class="payment-form"></div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-spin-clockwise" [fullScreen]="true"
    [name]="'processingOrder'">
    <p style="color: white"> {{'nuvei.paymentSection.spinner.processingOrder' | translate}} </p>
</ngx-spinner>
<!-- <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-spin-clockwise" [fullScreen]="true" [name]="'loadingCart'">
    <p style="color: white"> {{'Checkout.spinner.loadingCart' | translate}} </p>
</ngx-spinner> -->